import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopesUpdateModal',
  props: {
    stores: { default: () => [] }
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as { stores: string[] };





const isVisible = ref(true);

const storesToUpdate = computed((): Record<string, string>[] => {
    return props.stores.map((url) => ({
        name: url,
        updateUrl: `${process.env.VUE_APP_SHOPIFY_PRODUCT_PERSONALIZER_BASE_URL}/auth/login?shop=${url}`
    }));
});

const onGrantHandler = () => {
    window.open(storesToUpdate.value[0].updateUrl);
};

const onSkipHandler = () => {
    emit('close');
};

return { __sfc: true,emit, props, isVisible, storesToUpdate, onGrantHandler, onSkipHandler }
}

})